// extracted by mini-css-extract-plugin
export default {"form_wrapper":"styles_form_wrapper__1LuOo","logo":"styles_logo__LUT57","form":"styles_form__OtAs7","buttons":"styles_buttons__KKfV0"};